import React, { useState, useEffect } from "react";
import "./card_info_home.css";

const CardInfoHome = ({ title, description, isVisible }) => {
    const [count, setCount] = useState(0);
    const [isCounting, setIsCounting] = useState(false);
    const targetNumber = parseInt(title.replace(/\D/g, ''), 10) || 0;
    const suffix = (title.match(/[^\d]+$/) || ['+'])[0];

    useEffect(() => {
        if (isVisible && !isCounting) {
            setIsCounting(true);

            setTimeout(() => {
                let currentCount = 0;
                const increment = Math.max(targetNumber / 50, 0.04);
                const interval = 18;

                const timer = setInterval(() => {
                    currentCount += increment;
                    if (currentCount >= targetNumber) {
                        setCount(targetNumber);
                        clearInterval(timer);
                        return;
                    }
                    setCount(Math.floor(currentCount));
                }, interval);
            }, 200);
        }
    }, [isVisible, isCounting, targetNumber]);

    return (
        <div className={`card_info ${isVisible ? 'visible' : ''}`}>
            <div className="card_info_title">
                <p>{count}{suffix}</p>
            </div>
            <div className="card_info_description">
                <p>{description}</p>
            </div>
        </div>
    )
}

export default CardInfoHome